import styled from 'styled-components';
import { Text16Regular } from '../../../components/utils/Text/Text.styles';
import Image from '../../../components/utils/Image/Image';
import Video from '../../../components/utils/Video/Video';

export const PageContainer = styled.div`
  max-height: 100%;
  height: 100%;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  padding: 1.2rem 2.4rem 1.6rem 1.2rem;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const MediaCountText = styled(Text16Regular)`
  color: #6c737f;
`;

export const ListMedia = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 24rem;
  gap: 0.3rem;
  padding: 1.2rem 2.2rem 1.2rem 1.2rem;
  height: calc(100% - 12rem);
  overflow: auto;
  background: #f9fafb;
`;

export const MediaWrapper = styled.div`
  border-radius: 8px;
  overflow: hidden;
  height: 24rem;
  position: relative;
`;

export const StyledImage = styled(Image)`
  height: 100%;
  cursor: pointer;

  img {
    object-fit: cover;
  }
`;

export const StyledVideo = styled(Video)`
  height: 100%;
  cursor: pointer;

  video {
    object-fit: cover;
  }
`;

export const PlayIconWrapper = styled.div`
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  /* background: rgba(0, 0, 0, 0.56); */
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const FreePreviewWrapper = styled.div`
  border-radius: 4px;
  padding: 2px 6px;
  position: absolute;
  background: rgba(0, 0, 0, 0.56);
  z-index: 10;
  top: 2px;
  left: 2px;
  font-size: 1.1rem;
  font-weight: 500;
  color: #fff;
`;

export const NotValidMedia = styled.div`
  position: absolute;
  background: rgba(0, 0, 0, 0.76);
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    color: #fff;
    text-align: center;
  }
`;

export const IconWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  width: 3rem;
  background-color: transparent;
  border: none;
`;

export const EditIconWrapper = styled.button`
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
  z-index: 1000;
  height: 3rem;
  width: 3rem;
  background-color: #00000060;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
